import { SvgIcon } from 'components/ui';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './segments.module.scss';

const ConfirmationHeader = (props) => {
  const { segmentName } = props;

  return (
    <>
      <SvgIcon className={styles.warningIcon} name="warning_triangle" />
      <h3 className={styles.confirmationTitle}>
        {dictionary.segments.confirmation.title}
      </h3>
      {segmentName ? (
        <p className={styles.confirmationProduct}>
          You have selected
          <br />
          <strong>{segmentName}</strong>.
        </p>
      ) : null}
    </>
  );
};

ConfirmationHeader.propTypes = {
  segmentName: PropTypes.string.isRequired,
};

export default ConfirmationHeader;
